import * as _ from 'lodash';
import { IEntityTS } from '../../../shared/interfaces/entity-ts.interface';
import { TaxPercentage } from '../../../shared/constants/global.constants';
import { IVendor } from '../../vendors-page/vendors/vendors.interface';

export interface IExpense extends IEntityTS {
  expense?: IExpense;
  detail?: string;
  vendor?: IVendor;
  name?: string;
  description?: string;
  amount?: number;
  quantity?: number;
  total?: number;
  date?: Date;
  subtotal?: number;
  taxPercentage?: number;
  tax?: number;
}

export interface IDetailItemExpense {
  expense?: IExpense;
  detail?: string;
  vendor?: IVendor;
  name?: string;
  description?: string;
  amount?: number;
  quantity?: number;
  subtotal?: number;
  taxPercentage?: number;
  tax?: number;
  total?: number;
  date?: Date;
}

const emptyDetailItem: IDetailItemExpense= { detail: "", description: '', date: new Date(), quantity: 1, amount: 0, subtotal: 0, taxPercentage: TaxPercentage, tax: 0, total: 0 }
export const getEmptyDetailItemExpense = () => _.cloneDeep(emptyDetailItem)